import { PDFViewer } from '@react-pdf/renderer'
import { ModalComponent } from 'components/ModalComponent'
import { NewsArticle } from 'models/News/Article/NewsArticle'
import { getNewsSelectedArticles } from 'redux/news/newsSlice'
import React, { useEffect, useState } from 'react'
import { selectCommonUserData } from 'redux/commonUserData/commonUserDataSlice'
import { useAppSelector } from 'redux/hook'
import { getNewsCountries } from 'redux/news/newsSlice'

import { NewsArticlePdfDocument } from './NewsArticlePdfDocument/NewsArticlePdfDocument'
import { StyledNewsArticlePdfExportModal } from './NewsArticlePdfExportModal.styles'
import { getTranslations } from 'redux/translations/translationsSlice'
import newsService from 'services/News/NewsService'
import { NewsArticleRequest } from 'models/News/Homepage/NewsArticleRequest'

interface INewsArticlePdfExportModalProps {
  article: NewsArticle
  isOpen: boolean
  title: string
  onClose: () => void
}

export const NewsArticlePdfExportModal: React.FC<
  INewsArticlePdfExportModalProps
> = ({ article, isOpen, title, onClose }: INewsArticlePdfExportModalProps) => {
  const commonUserData = useAppSelector(selectCommonUserData)
  const translations = useAppSelector(getTranslations)
  const countries = useAppSelector(getNewsCountries)
  const selectedArticleIdList = useAppSelector(getNewsSelectedArticles)
  const [selectedArticles, setSelectedArticles] = useState<NewsArticle[]>([])

  useEffect(() => {
    if (selectedArticleIdList.length > 0) {
      const fetchArticles = async () => {
        const articles = await Promise.all(
            selectedArticleIdList.map(async id => {
            const getArticleRequest: NewsArticleRequest = {
              article:  {
                id: id,
                languageId: commonUserData.languageId,
              },
            }
           const newsResponse = await newsService.getArticleDetailByArticleId(getArticleRequest)
            return newsResponse?.article
          })
        )
        setSelectedArticles(articles.filter(article => article !== undefined) as NewsArticle[])
      }
      fetchArticles()
    }
  }, [selectedArticleIdList, commonUserData.languageId])
  

  return (
    <StyledNewsArticlePdfExportModal>
      <ModalComponent
        maxWidth="lg"
        modalVisible={isOpen}
        closeButton
        title={title}
        onSecondaryClick={onClose}
      >
        <PDFViewer showToolbar width="1128px" height="740px">
          <NewsArticlePdfDocument
            article={article}
            selectedArticles={selectedArticles}
            countries={countries}
            translations={translations}
            languageId={commonUserData.languageId}
          />
        </PDFViewer>
      </ModalComponent>
    </StyledNewsArticlePdfExportModal>
  )
}
